import { Route, Routes } from 'react-router-dom';
import AlertRuleCreatePage from './pages/AlertRuleCreatePage';
import AlertRulesPage from './pages/AlertRules';
import AlertRulePage from './pages/AlertRule';
import AlertsPage from './pages/Alerts';
import CamerasPage from './pages/Cameras';
import DatabaseEventsPage from './pages/DatabaseEvents';
import EventPage from './pages/Event';
import HomePage from './pages/Home';
import Layout from './pages/Layout';
import LogoutPage from './pages/Logout';
import NotFoundPage from './pages/NotFound';
import QueryResultsPage from './pages/QueryResults';
import EventsPage from './pages/Events';
import SetupHdmiPage from './pages/SetupHdmiPage';
import PersonPage from './pages/PersonPage';
import PersonsPage from './pages/Persons';
import SettingsMemberPage from './pages/SettingsMember';
import SettingsPage from './pages/Settings';
import SignInPage from './pages/SignIn';
import SourcePage from './pages/Source';
import SourcesPage from './pages/Sources';
import ReportPage from './pages/Report';
import ReportEventPage from './pages/ReportEvent';
import ReportsPage from './pages/Reports';
import VehiclePage from './pages/VehiclePage';
import VehiclesPage from './pages/Vehicles';
import { PermissionGuard } from '@/components/OrgOwnerGuard/OrgOwnerGuard';
import { FeatureGuard } from '@/components/FeatureGuard';
import { QueryUrlSyncGuard } from '@/components/QueryUrlSyncGuard';
import { AppRoutes } from '@/constants/routes';
import { Permission } from '@/types/permissions';

export default function Router() {
    return (
        <Routes>
            <Route path={AppRoutes.LOGOUT} element={<LogoutPage />} />
            <Route path={AppRoutes.SIGN_IN} element={<SignInPage />} />
            <Route element={<Layout />}>
                <Route
                    path={AppRoutes.ALERT_RULE_ALERTS}
                    element={
                        <FeatureGuard flag="alertsEnabled">
                            <QueryUrlSyncGuard>
                                <AlertsPage />
                            </QueryUrlSyncGuard>
                        </FeatureGuard>
                    }
                />
                <Route
                    path={AppRoutes.ALERT_RULES}
                    element={
                        <FeatureGuard flag="alertsEnabled">
                            <AlertRulesPage />
                        </FeatureGuard>
                    }
                />
                <Route
                    path={AppRoutes.ALERT_RULES_CREATE}
                    element={
                        <FeatureGuard flag="alertsEnabled">
                            <AlertRuleCreatePage />
                        </FeatureGuard>
                    }
                />
                <Route
                    path={AppRoutes.ALERT_RULE}
                    element={
                        <FeatureGuard flag="alertsEnabled">
                            <AlertRulePage />
                        </FeatureGuard>
                    }
                />
                <Route
                    path={AppRoutes.ALERT_RULES_EDIT}
                    element={
                        <FeatureGuard flag="alertsEnabled">
                            <AlertRuleCreatePage />
                        </FeatureGuard>
                    }
                />
                <Route
                    path={AppRoutes.ALERTS}
                    element={
                        <FeatureGuard flag="alertsEnabled">
                            <QueryUrlSyncGuard>
                                <AlertsPage />
                            </QueryUrlSyncGuard>
                        </FeatureGuard>
                    }
                />
                <Route
                    path={AppRoutes.DATABASE_EVENTS}
                    element={
                        <QueryUrlSyncGuard>
                            <DatabaseEventsPage />
                        </QueryUrlSyncGuard>
                    }
                />
                <Route
                    path={AppRoutes.CAMERAS}
                    element={
                        <FeatureGuard flag="liveCamerasEnabled">
                            <CamerasPage />
                        </FeatureGuard>
                    }
                />
                <Route path={AppRoutes.EVENT} element={<EventPage />} />
                <Route
                    path={AppRoutes.EVENTS}
                    element={
                        <QueryUrlSyncGuard>
                            <EventsPage />
                        </QueryUrlSyncGuard>
                    }
                />
                <Route path={AppRoutes.PERSON} element={<PersonPage />} />
                <Route path={AppRoutes.PERSONS} element={<PersonsPage />} />
                <Route path={AppRoutes.HOME} element={<HomePage />} />
                <Route
                    path={AppRoutes.QUERY_RESULTS}
                    element={<QueryResultsPage />}
                />
                <Route
                    path={AppRoutes.SETUP_HDMI}
                    element={
                        <FeatureGuard flag="hdmiEnabled">
                            <SetupHdmiPage />
                        </FeatureGuard>
                    }
                />
                <Route path={AppRoutes.SOURCE} element={<SourcePage />} />
                <Route path={AppRoutes.SOURCES} element={<SourcesPage />} />
                <Route path={AppRoutes.REPORTS} element={<ReportsPage />} />
                <Route
                    path={AppRoutes.REPORT_EVENT}
                    element={<ReportEventPage />}
                />
                <Route path={AppRoutes.REPORT} element={<ReportPage />} />
                <Route path={AppRoutes.VEHICLE} element={<VehiclePage />} />
                <Route path={AppRoutes.VEHICLES} element={<VehiclesPage />} />
                <Route
                    path={AppRoutes.SETTINGS_MEMBER}
                    element={
                        <PermissionGuard
                            requiredPermission={
                                Permission.ORGANIZATION_SETTINGS_VIEW
                            }
                        >
                            <SettingsMemberPage />
                        </PermissionGuard>
                    }
                />
                <Route
                    path={AppRoutes.SETTINGS}
                    element={
                        <PermissionGuard
                            requiredPermission={
                                Permission.ORGANIZATION_SETTINGS_VIEW
                            }
                        >
                            <SettingsPage />
                        </PermissionGuard>
                    }
                />
                <Route
                    path="/settings/:section"
                    element={
                        <PermissionGuard
                            requiredPermission={
                                Permission.ORGANIZATION_SETTINGS_VIEW
                            }
                        >
                            <SettingsPage />
                        </PermissionGuard>
                    }
                />
                <Route path={AppRoutes.NOT_FOUND} element={<NotFoundPage />} />
            </Route>
            <Route path="*" element={<NotFoundPage />} />
        </Routes>
    );
}
